<template>
  <div>
    <div v-if="pagedProducts.length">
      <app-product-grid :products="pagedProducts"></app-product-grid>
      <app-pager v-if="args.maxPage" :args="args"></app-pager>
    </div>
    <div v-else>
      <p>{{ $i18n.no_products_found }}</p>
    </div>
  </div>
</template>

<script>
import ProductGrid from "./product/Grid";
import Pager from "./Pager";

export default {
  components: {
    appProductGrid: ProductGrid,
    appPager: Pager
  },
  data() {
    return {
      args: {
        paged: 1,
        perPage: this.$postsPerPage,
        maxPage: null
      },
      filter: {
        tags: [],
        price: {
          min: null,
          max: null
        },
        attributes: [],
        onSale: false
      },
      orderBy: ""
    };
  },
  computed: {
    products() {
      return this.$store.getters.products;
    },
    filteredProducts() {
      let products = this.products;

      // Attributes.
      if (this.filter.attributes && this.filter.attributes.length) {
        products = products.filter(product => {
          let condition = false;
          // Check if attr present
          let check = this.filter.attributes.every(attr => {
            return product.attributes.some(prodAttr => {
              return attr.id == prodAttr.id;
            });
          });

          // Filter attr
          if (check) {
            var validAttr = [];
            product.attributes.forEach(productAttr => {
              this.filter.attributes.forEach(filterAttr => {
                // if attribute exists in product
                if (filterAttr.id === productAttr.id) {
                  let exists;
                  if (filterAttr.slider) {
                    exists = productAttr.terms.some(attr => {
                      return (
                        filterAttr.min <= attr.name &&
                        attr.name <= filterAttr.max
                      );
                    });
                  } else {
                    exists = filterAttr.values.some(term => {
                      return productAttr.terms.some(prodTerm => {
                        return prodTerm.name == term;
                      });
                    });
                  }
                  validAttr.push(exists);
                }
              });
            });

            condition = !validAttr.includes(false);
          }

          return condition;
        });
      }

      // Tags.
      if (this.filter.tags && this.filter.tags.length) {
        products = products.filter(product => {
          if (product.tags) {
            return product.tags.some(prodTag => {
              return this.filter.tags.includes(prodTag.term_id);
            });
          } else {
            return false;
          }
        });
      }

      // Prices.
      if (this.filter.price.min || this.filter.price.max) {
        products = products.filter(product => {
          let included = null;
          if (product.on_sale) {
            let sale_price = product.sale_price_raw;

            included =
              this.filter.price.min <= sale_price &&
              sale_price <= this.filter.price.max;
          } else {
            let regular_price = product.regular_price_raw;

            included =
              this.filter.price.min <= regular_price &&
              regular_price <= this.filter.price.max;
          }
          return included;
        });
      }

      if (this.filter.onSale) {
        products = products.filter(product => {
          return product.on_sale;
        });
      }

      this.args.maxPage = Math.ceil(products.length / this.args.perPage);

      return products;
    },

    orderedProducts() {
      let products = this.filteredProducts;
      if (this.orderBy) {
        switch (this.orderBy) {
          case "menu_order":
            products.sort((a, b) => {
              return a.menu_order - b.menu_order;
            });
            break;
          case "popularity":
            products.sort((a, b) => {
              return a.total_sales - b.total_sales;
            });
            break;
          case "price":
            products.sort((a, b) => {
              if (a.on_sale) {
                let a_sale_price = a.sale_price_raw;
                if (b.on_sale) {
                  let b_sale_price = b.sale_price_raw;
                  return a_sale_price - b_sale_price;
                } else {
                  let b_regular_price = b.regular_price_raw;
                  return a_sale_price - b_regular_price;
                }
              } else {
                let a_regular_price = a.regular_price_raw;
                if (b.on_sale) {
                  let b_sale_price = b.sale_price_raw;
                  return a_regular_price - b_sale_price;
                } else {
                  let b_regular_price = b.regular_price_raw;

                  return a_regular_price - b_regular_price;
                }
              }
            });
            break;
          case "price-desc":
            products.sort((a, b) => {
              if (a.on_sale) {
                let a_sale_price = a.sale_price_raw;
                if (b.on_sale) {
                  let b_sale_price = b.sale_price_raw;
                  return b_sale_price - a_sale_price;
                } else {
                  let b_regular_price = b.regular_price_raw;
                  return b_regular_price - a_sale_price;
                }
              } else {
                let a_regular_price = a.regular_price_raw;
                if (b.on_sale) {
                  let b_sale_price = b.sale_price_raw;
                  return b_sale_price - a_regular_price;
                } else {
                  let b_regular_price = b.regular_price_raw;
                  return b_regular_price - a_regular_price;
                }
              }
            });
            break;
          case "date":
            products.sort((a, b) => {
              return b.date - a.date;
            });
            break;
          case "power":
            products.sort((a, b) => {
              return a.power - b.power;
            });
            break;
          case "power-desc":
            products.sort((a, b) => {
              return b.power - a.power;
            });
            break;
        }
      }
      return products;
    },

    pagedProducts() {
      let from = (this.args.paged - 1) * this.args.perPage;
      let to = this.args.paged * this.args.perPage;
      return this.orderedProducts.slice(from, to);
    }
  },
  watch: {
    "$route.query": {
      deep: true,
      handler(query) {
        this.orderBy = query.orderby ? query.orderby : null;
        this.args.paged = query.page ? query.page : 1;
        this.filter.price = query.price
          ? JSON.parse(query.price)
          : {
            min: null,
            max: null
          };
        this.filter.tags = query.tags && query.tags.length ? query.tags : [];
        this.filter.onSale = query.onsale ? query.onsale : false;
        this.filter.attributes = query.attributes
          ? JSON.parse(query.attributes)
          : null;

        window.localStorage.setItem("catalogUrl", false);
      }
    }
  },
  created() {
    const query = this.$route.query;

    if (query.page) {
      this.args.paged = query.page;
    }
    if (query.orderby) {
      this.orderBy = query.orderby;
    }
    if (query.onsale) {
      this.onSale = query.onsale;
    }
    if (query.price) {
      this.filter.price = JSON.parse(query.price);
    }
    if (query.tags && query.tags.length) {
      this.filter.tags = JSON.parse(query.tags);
    }
    if (query.attributes) {
      this.filter.attributes = JSON.parse(query.attributes);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Products.vue